import React from 'react';
export function RegularMaintenanceSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-3042">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3043">
        Regular Maintenance For EDM
      </h2>
      <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-3044">
        <div className="space-y-4 text-gray-700 text-lg leading-relaxed" data-id="element-3045">
          <p data-id="element-3046">
            Keeping a daily logbook next to the machine or on a nearby PC is a
            step in the right direction. We are all too busy juggling 15 other
            projects at one time. Face it, who is going to remember the last
            time the power contacts or filters were changed?
          </p>
          <p data-id="element-3047">
            Preventive maintenance is the best maintenance. Keeping a diary of
            how long the wear parts and consumables last provides a history so
            that you know when to get off the race track and come in for a quick
            pit stop. Some WEDMs even have fairly accurate timers that can give
            you a heads-up notice.
          </p>
          <p data-id="element-3048">
            The most important thing recorded in your logbook is the weekly WEDM
            machine "cutting hours." Each year you are given 8,760 hours. You
            don't have the option of buying any more time - you just have the
            challenge of deciding how to use it all up. The more weekly cutting
            hours that you can squeeze out of the WEDM is the best measure of
            your overall productivity.
          </p>
        </div>
        <div data-id="element-3049">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/EDM%20Images/EDM%20Maintenance.jpg" alt="EDM Maintenance" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3050" />
        </div>
      </div>
    </div>;
}